/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/prefer-immediate-return */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-else-return */
import { IPublicClientApplication } from "@azure/msal-browser";
import {
    addDays,
    addSeconds,
    format,
    isAfter,
    isBefore,
    isSameDay,
    isValid,
    isWithinInterval,
    parseISO,
} from "date-fns";
import {
    StatusCheckinEnum,
    StatusCheckinEnumLabel,
    getLabelStatusCheckinEnum,
} from "../model/Enums/StatusCheckinEnum";
import {
    isOvertimeCard,
    tenHourLimit,
    TipoCartaoEnum,
} from "../model/Enums/TipoCartaoEnum";
import { MASK_DATE, MASK_TIMESTAMP } from "./constants";
import { ValidationResult } from "./types/ValidationResult";
import {
    getEnumByLabel,
    isCampusHoliday,
    isNationalHoliday,
    isAbono,
} from "./StatusCheckinUtils";
import DateUtils from "./DateUtils";
import { VigenciaPlanoAtividade } from "../model/dto/VigenciaPlanoAtividade";
import CartoesService from "../service/Docente/CartoesService";
import GenericUtils from "./GenericUtils";

type Holiday = {
    campus: string;
    color: string;
    description: string;
    end: string;
    id: number;
    start: string;
    title: string;
    type: string;
};

const getTargetHoliday = (movedCard: any, holidays: Holiday[]) => {
    // console.log("getTargetHoliday", { movedCard, holidays });
    return holidays.filter(
        (holiday) =>
            movedCard.data === holiday.start || movedCard.data === holiday.end
    );
};

const getIsCardStatusHoliday = (statusCheckin: string) => {
    const statusEnumLabel = getEnumByLabel(statusCheckin);
    return (
        isCampusHoliday(statusEnumLabel) || isNationalHoliday(statusEnumLabel)
    );
};
const getIsCardStatusAbono = (statusCheckin: string) => {
    const statusEnumLabel = getEnumByLabel(statusCheckin);
    return (
        isAbono(statusEnumLabel)
    );
};


const getHolidayStatus = (newCard: any, targetHoliday: Holiday[]): string => {
    if (targetHoliday.filter((holiday) => holiday.type === "N").length)
        return getLabelStatusCheckinEnum(StatusCheckinEnum.FeriadoNacional);

    if (
        targetHoliday.filter(
            (holiday) =>
                holiday.campus === newCard.abrangencia?.campus &&
                holiday.type === "R"
        ).length
    )
        return getLabelStatusCheckinEnum(StatusCheckinEnum.Recesso);

    if (
        targetHoliday.filter(
            (holiday) =>
                holiday.campus === newCard.abrangencia?.campus &&
                holiday.type === "M"
        ).length
    )
        return getLabelStatusCheckinEnum(StatusCheckinEnum.FeriadoMunicipal);

    return "";
};

const checkHolidayCard = async (
    newCard: any,
    holidays: Holiday[],
    msalInstance: IPublicClientApplication
) => {
    const targetHoliday = holidays.length
        ? getTargetHoliday(newCard, holidays)
        : [];

    const isCardStatusHoliday = getIsCardStatusHoliday(newCard.statusCheckin);

    if (targetHoliday.length) {
        const holidayStatus = getHolidayStatus(newCard, targetHoliday);

        if (holidayStatus.length) return holidayStatus;

        return isCardStatusHoliday
            ? newCard.statusCheckinAnterior
            : newCard.statusCheckin;
    } else {
        if (isCardStatusHoliday) {
            // console.log(
            //     "Entrou no if isCardStatusHoliday dentro da checkHolidayCard"
            // );

            const response = await CartoesService.getCardLastStatusFromBackend(
                msalInstance,
                newCard.cartaoAgendaId
            );

            if (GenericUtils.isSuccessStatus(response)) {
                const lastStatus = response.data;
                // console.log("lastStatus", lastStatus);
                return getLabelStatusCheckinEnum(lastStatus as StatusCheckinEnum);
            }

            return (
                getLabelStatusCheckinEnum(
                    newCard.statusCheckinAnterior as StatusCheckinEnum
                ) ||
                getLabelStatusCheckinEnum(StatusCheckinEnum.AguardandoCheckin)
            );
        }

        return newCard.statusCheckin;
    }
};

const typeCardsHoraLetivaRE = (newCard: any) => {
    return (
        newCard.cartaoTipo?.cartaoTipoId === 10 ||
        newCard.cartaoTipo?.cartaoTipoId === 11
    );
};
const typeCards = (newCard: any) => {
    return (
        newCard.cartaoTipo?.cartaoTipoId === 6 ||
        newCard.cartaoTipo?.cartaoTipoId === 7 ||
        newCard.cartaoTipo?.cartaoTipoId === 8
    );
};
const validaIntervalo = (diaInteiro: any, dataCard: any, dataAbono: any) => { 
    if(diaInteiro){
        return true
    } 
    return isWithinInterval(dataCard, {
        start: addSeconds(parseISO(dataAbono.date+ 'T' + dataAbono.horaInicio.trim()), 1),
        end: addSeconds(parseISO(dataAbono.date+ 'T' + dataAbono.horaFim.trim()), -1),
    })
}

const validaTodosProfessores = (todosProfessores: any, listaProfessores: any, professor: any) => { 
    if(todosProfessores){
        return true
    } 
    return listaProfessores.some(
        (docente: any) => Number(docente.id) === professor.docenteID
    )
}

const checkAbonoCard = async (
    newCard: any,
    dataAbonos: any[],
    professor: any,
    msalInstance: IPublicClientApplication
) => {
    const startNewCard = parseISO(newCard.start?.trim());
    const isCardStatusAbono = getIsCardStatusAbono(newCard.statusCheckin);
    if (
        dataAbonos.filter(
            (abono) =>
                Number(abono.centroResultadoId) === professor.cr &&
                abono.date === newCard.data &&
                typeCardsHoraLetivaRE(newCard) &&
                validaIntervalo(abono.diaInteiro, startNewCard, abono) &&
                validaTodosProfessores(abono.todosProfessores, abono.docentes, professor)
        ).length
    ) {

        return getLabelStatusCheckinEnum(StatusCheckinEnum.AbonoAdministrativo);

    } else {
        if (isCardStatusAbono) {
            // console.log(
            //     "Entrou no if isCardStatusHoliday dentro da checkHolidayCard"
            // );

            const response = await CartoesService.getCardLastStatusFromBackend(
                msalInstance,
                newCard.cartaoAgendaId
            );

            if (GenericUtils.isSuccessStatus(response)) {
                const lastStatus = response.data;
                // console.log("lastStatus", lastStatus);
                return getLabelStatusCheckinEnum(lastStatus as StatusCheckinEnum);
            }

            return (
                getLabelStatusCheckinEnum(
                    newCard.statusCheckinAnterior as StatusCheckinEnum
                ) ||
                getLabelStatusCheckinEnum(StatusCheckinEnum.AguardandoCheckin)
            );
        }

        return newCard.statusCheckin;
    }
};
const checkLastStatus = (newCard: any, status: string) => {
    if (newCard.statusCheckin === status) return newCard.statusCheckinAnterior;

    const isCardStatusHoliday = getIsCardStatusHoliday(newCard.statusCheckin);
    const targetStatusEnum = getEnumByLabel(status);
    const isTargetStatusHoliday =
        isCampusHoliday(targetStatusEnum) ||
        isNationalHoliday(targetStatusEnum);

    if (isCardStatusHoliday && isTargetStatusHoliday)
        return newCard.statusCheckinAnterior;

    return newCard.statusCheckin;
};

const removeActualCardFromScheduleEvents = (
    scheduleEvents: any[],
    card: any
): any[] => {
    return scheduleEvents.filter((item) => item.id !== card.id);
};

const getEventsByDate = (date: Date, schedulesEvents: any[]) => {
    return schedulesEvents.filter(
        (item) =>
            item?.data === format(date, MASK_DATE) &&
            item?.title?.toLowerCase() !== "recreio - estudantes"
    );
};

const verifyIfAllCardsHasId = (cards: any[]) => {
    const cardsWithoutRecreation = cards.filter(
        (item) => item.title !== "Recreio - Estudantes"
    );

    return cardsWithoutRecreation.every((item) => item.cartaoAgendaId);
};

const dailyNormalClassHoursExceeded = (
    card: any,
    scheduleEvents: any[]
): boolean => {
    const cardType = card.cartaoTipo?.cartaoTipoId;
    if (
        cardType === TipoCartaoEnum.Intrajornada ||
        tenHourLimit(cardType) ||
        cardType === TipoCartaoEnum.HoraExtraImportacao ||
        cardType === TipoCartaoEnum.HoraExtraTela
    )
        return false;

    const totalHours: number = getEventsByDate(
        parseISO(card.data),
        scheduleEvents
    )
        .filter(
            (item) =>
                item.duracaoHoraAula &&
                item.id !== card.id &&
                item.cartaoTipo?.cartaoTipoId !== TipoCartaoEnum.Intrajornada &&
                !tenHourLimit(item.cartaoTipo?.cartaoTipoId) &&
                !isOvertimeCard(item)
        )
        .reduce(
            (a, b) => a + Number(b.duracaoHoraAula),
            Number(card.duracaoHoraAula)
        );

    return totalHours / 60 > 8;
};

const dailySpecialClassHoursExceeded = (
    card: any,
    scheduleEvents: any[]
): boolean => {
    if (
        card.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.Intrajornada ||
        card.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.HoraExtraImportacao ||
        card.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.HoraExtraTela
    )
        return false;

    const totalSpecialHours: number =
        getEventsByDate(parseISO(card.data), scheduleEvents)
            .filter(
                (item) =>
                    item.duracaoHoraAula &&
                    item.id !== card.id &&
                    item.cartaoTipo?.cartaoTipoId !==
                        TipoCartaoEnum.Intrajornada &&
                    tenHourLimit(item.cartaoTipo?.cartaoTipoId)
            )
            .reduce(
                (a, b) => a + Number(b.duracaoHoraAula),
                Number(card.duracaoHoraAula)
            ) / 60;

    const totalHours: number =
        getEventsByDate(parseISO(card.data), scheduleEvents)
            .filter(
                (item) =>
                    item.duracaoHoraAula &&
                    item.id !== card.id &&
                    item.cartaoTipo?.cartaoTipoId !==
                        TipoCartaoEnum.Intrajornada &&
                    item.cartaoTipo?.cartaoTipoId !==
                        TipoCartaoEnum.HoraExtraImportacao &&
                    item.cartaoTipo?.cartaoTipoId !==
                        TipoCartaoEnum.HoraExtraTela &&
                    !tenHourLimit(item.cartaoTipo?.cartaoTipoId)
            )
            .reduce((a, b) => a + Number(b.duracaoHoraAula), 0) / 60;
    const limite = 10 - totalHours;
    return totalSpecialHours > limite;
};

const checkOutValidityPeriod = (card: any): boolean => {
    const dateCard = parseISO(card.data?.trim());
    const startDateValidity = parseISO(card.dataVigenciaInicio?.trim());
    const endDateValidity = parseISO(card.dataVigenciaFim?.trim());

    return (
        isBefore(dateCard, startDateValidity) ||
        isAfter(dateCard, endDateValidity)
    );
};

const checkNewDateBeforeCurrentDateTime = (card: any) => {
    const currentDate = parseISO(format(new Date(), MASK_TIMESTAMP));
    const newDateCard = parseISO(card.start?.trim());
    const cardIsOvertimeScreen =
        card.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.HoraExtraTela;

    return cardIsOvertimeScreen ? false : isBefore(newDateCard, currentDate);
};

const checkIfCardsHasCheckin = (cards: any[]): boolean => {
    return cards.some(
        (item: any) =>
            item.statusCheckin ===
                StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.CheckinRealizado
                ) ||
            item.statusCheckin ===
                StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.CheckinJustificado
                ) ||
            item.statusCheckin ===
                StatusCheckinEnumLabel.get(
                    StatusCheckinEnum.AbonoAdministrativo
                ) ||
            item.statusCheckin ===
                StatusCheckinEnumLabel.get(StatusCheckinEnum.AbonoLegal)
    );
};

const checkIfMovedCardIsOverlappingAnotherCard = (
    movedCard: any,
    actual: any,
    isHoliday: boolean
): boolean => {
    const startNewCard = parseISO(movedCard.start?.trim());
    const endNewCard = parseISO(movedCard.end?.trim());
    const movedCardIsOvertime =
        movedCard.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.HoraExtraTela;
    const actualCardIsOvertime = isOvertimeCard(actual);
    const isOverlapping =
        isWithinInterval(startNewCard, {
            start: addSeconds(
                parseISO(
                    actual.startTime
                        ? movedCard.data + "T" + actual.startTime.trim()
                        : actual.start.trim()
                ),
                1
            ),
            end: addSeconds(
                parseISO(
                    actual.endTime
                        ? movedCard.data + "T" + actual.endTime.trim()
                        : actual.end?.trim()
                ),
                -1
            ),
        }) ||
        isWithinInterval(endNewCard, {
            start: addSeconds(
                parseISO(
                    actual.startTime
                        ? movedCard.data + "T" + actual.startTime.trim()
                        : actual.start.trim()
                ),
                1
            ),
            end: addSeconds(
                parseISO(
                    actual.endTime
                        ? movedCard.data + "T" + actual.endTime.trim()
                        : actual.end?.trim()
                ),
                -1
            ),
        }) ||
        isWithinInterval(
            addSeconds(
                parseISO(
                    actual.startTime
                        ? movedCard.data + "T" + actual.startTime.trim()
                        : actual.start.trim()
                ),
                1
            ),
            {
                start: startNewCard,
                end: endNewCard,
            }
        ) ||
        isWithinInterval(
            addSeconds(
                parseISO(
                    actual.endTime
                        ? movedCard.data + "T" + actual.endTime.trim()
                        : actual.end?.trim()
                ),
                -1
            ),
            {
                start: startNewCard,
                end: endNewCard,
            }
        );
    const actualCardWasChecked = checkIfCardsHasCheckin([actual]);

    if (movedCardIsOvertime && actualCardIsOvertime && isOverlapping) {
        return true;
    }

    if (
        movedCardIsOvertime &&
        !actualCardIsOvertime &&
        isHoliday &&
        !actualCardWasChecked
    ) {
        return false;
    }

    return isOverlapping;
};

const checkOverlap = (
    movedCard: any,
    scheduleEvents: any[],
    holidays: Holiday[]
): boolean => {
    const isHoliday = !!getTargetHoliday(movedCard, holidays).length;
    const filteredScheduleEvents = scheduleEvents.filter((actualCard) => {
        if (movedCard.cartaoTipo.cartaoTipoId !== 3) {
            return (
                actualCard.id !== movedCard.id &&
                actualCard?.statusCheckin !== "Dispensado" &&
                actualCard?.title !== "Recreio - Estudantes"
            );
        } else {
            return (
                actualCard.id !== movedCard.id &&
                actualCard?.statusCheckin !== "Dispensado"
            );
        }
    });

    return filteredScheduleEvents.some((actualCard) => {
        return checkIfMovedCardIsOverlappingAnotherCard(
            movedCard,
            actualCard,
            isHoliday
        );
    });
};

const getTomorrowFirstCard = (
    newCardEndDate: Date,
    scheduleEvents: any[]
): Date => {
    return parseISO(
        getEventsByDate(addDays(newCardEndDate, -1), scheduleEvents)
            .sort((a, b) => a.end?.trim().localeCompare(b.end?.trim()))
            .at(-1)
            ?.end?.trim()
    );
};

const getYesterdayLastCard = (
    newCardStartDate: Date,
    scheduleEvents: any[]
): Date => {
    return parseISO(
        getEventsByDate(addDays(newCardStartDate, +1), scheduleEvents)
            .sort((a, b) => a.start.trim().localeCompare(b.start.trim()))
            .at(0)
            ?.start.trim()
    );
};

const getAllYesterdayCardsThatExceedElevenHours = (
    allYesterdayCards: any[],
    startDateNewCard: Date
): any[] => {
    return allYesterdayCards.filter((item) => {
        return (
            Math.abs(
                DateUtils.diffenceBetweenDatesInMinutes(
                    startDateNewCard,
                    parseISO(item.end?.trim())
                )
            ) <= 660
        );
    });
};

const getAllTomorrowCardsThatExceedElevenHours = (
    allTomorrowCards: any[],
    endDateNewCard: Date
): any[] => {
    return allTomorrowCards.filter((item) => {
        return (
            Math.abs(
                DateUtils.diffenceBetweenDatesInMinutes(
                    parseISO(item.start?.trim()),
                    endDateNewCard
                )
            ) <= 660
        );
    });
};

const hourRangeExceededForOvertimeCards = (
    card: any,
    scheduleEvents: any[]
): {
    exceededYesterdayCards: any[];
    exceededTomorrowCards: any[];
} => {
    const responseObject = {
        exceededYesterdayCards: [] as any[],
        exceededTomorrowCards: [] as any[],
    };

    if (!isOvertimeCard(card)) return responseObject;

    const startDateNewCard = parseISO(card.start?.trim());
    const endDateNewCard = parseISO(card.end?.trim());

    const endLastDayCard = getTomorrowFirstCard(endDateNewCard, scheduleEvents);
    const startLaterDayCard = getYesterdayLastCard(
        startDateNewCard,
        scheduleEvents
    );

    if (isValid(endLastDayCard)) {
        const allYesterdayCards = getEventsByDate(
            endLastDayCard,
            scheduleEvents
        );

        responseObject.exceededYesterdayCards =
            getAllYesterdayCardsThatExceedElevenHours(
                allYesterdayCards,
                startDateNewCard
            );
    }

    if (isValid(startLaterDayCard)) {
        const allTomorrowCards = getEventsByDate(
            startLaterDayCard,
            scheduleEvents
        );

        responseObject.exceededTomorrowCards =
            getAllTomorrowCardsThatExceedElevenHours(
                allTomorrowCards,
                endDateNewCard
            );
    }

    return responseObject;
};

function isIntervalLessThanOrEqualTo11Hours(date1: Date, date2: Date): boolean {
    const MILLIS_IN_HOUR = 1000 * 60 * 60;
    const MILLIS_IN_MINUTE = 1000 * 60;

    // Calcula a diferença em milissegundos entre as duas datas
    const diffMillis = Math.abs(date2.getTime() - date1.getTime());

    // Calcula o número de horas e minutos dessa diferença
    const hours = Math.floor(diffMillis / MILLIS_IN_HOUR);
    const minutes = Math.floor(
        (diffMillis % MILLIS_IN_HOUR) / MILLIS_IN_MINUTE
    );

    const validBefore = hours < 11 || (hours === 11 && minutes === 0);
    // Retorna true se o intervalo de horas e minutos for menor ou igual a 11 horas
    return validBefore;
}

const hourRangeExceeded = (cardFilho: any, scheduleEvents: any[]): boolean => {
    if (
        isOvertimeCard(cardFilho) ||
        cardFilho.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.Intrajornada
    ) {
        return false;
    }

    const filteredScheduleEvents = removeActualCardFromScheduleEvents(
        scheduleEvents,
        cardFilho
    );

    const startDateNewCard = parseISO(cardFilho.start?.trim());

    const endDateNewCard = parseISO(cardFilho.end?.trim());

    const endLastDayCard = getTomorrowFirstCard(
        endDateNewCard,
        filteredScheduleEvents
    );

    const startLaterDayCard = getYesterdayLastCard(
        startDateNewCard,
        filteredScheduleEvents
    );

    return (
        isIntervalLessThanOrEqualTo11Hours(startDateNewCard, endLastDayCard) ||
        isIntervalLessThanOrEqualTo11Hours(endDateNewCard, startLaterDayCard)
    );
};

const checkDoubleIntradayDate = (card: any, scheduleEvents: any[]) => {
    if (card.cartaoTipo?.cartaoTipoId !== TipoCartaoEnum.Intrajornada)
        return false;

    return scheduleEvents.some(
        (item) =>
            item?.data === card.data &&
            item.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.Intrajornada &&
            item.id !== card.id
    );
};

const checkLastDateBeforeCurrentDateTime = (
    card: any,
    scheduleEvents: any[]
) => {
    const currentDate = parseISO(format(new Date(), MASK_TIMESTAMP));
    const lastDateCard = parseISO(
        scheduleEvents.find((item) => item.id === card.id)?.start?.trim()
    );

    return isOvertimeCard(card)
        ? false
        : card.cartaoAgendaId && isBefore(lastDateCard, currentDate);
};

const checkIfOvertimeCardScreenIsAllocatedInSameDay = (
    card: any,
    today: Date = new Date()
) => {
    const cardDate = parseISO(card.data?.trim());
    return isSameDay(cardDate, today);
};

/**
 *
 *
 *
 *
 *
 *
 */

async function dailyNormalClassHoursExceededValidation(
    card: any,
    scheduleEvents: any[]
): Promise<ValidationResult> {
    if (dailyNormalClassHoursExceeded(card, scheduleEvents)) {
        return {
            error: true,
            message: "Você só pode cadastrar 8 horas/aula não letiva por dia.",
        };
    }
    return { error: false };
}

async function isOvertimeCardValidation(
    card: any,
    disableSave: boolean,
    scheduleEvents: any[]
): Promise<ValidationResult> {
    if (
        isOvertimeCard(card) &&
        !verifyIfAllCardsHasId(scheduleEvents) &&
        !disableSave
    ) {
        return {
            error: true,
            message:
                "Não é possível mover cartões de Hora Letiva RE caso sua agenda ainda não tenha sido salva.",
        };
    }

    if (
        card.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.HoraExtraTela &&
        !checkIfOvertimeCardScreenIsAllocatedInSameDay(card)
    ) {
        return {
            error: true,
            message:
                "Os cartões de Hora Letiva RE só podem ser alocados na mesma data em que foram criados.",
        };
    }

    return { error: false };
}

const ATIVIDADE_NAO_INSERIDA = "ATIVIDADE NÃO INSERIDA";
const ABONO_ADMINISTRATIVO = "Abono Administrativo";
const MSG_ALOCACAO_NAO_PERMITIDA_ABONO =
    "Não é possível alocar atividades em dias de abono administrativo.";
const FERIADO_OU_RECESSO = "Feriado ou Recesso";
const MSG_ALOCACAO_NAO_PERMITIDA_FERIADO_RECESSO =
    "Não é possível alocar este tipo de cartão em dias de feriado ou recesso.";
async function checkOutValidityPeriodValidation(
    card: any
): Promise<ValidationResult> {
    if (checkOutValidityPeriod(card)) {
        const message =
            "Não é possível inserir atividades na Agenda fora do período letivo";
        return { error: true, title: ATIVIDADE_NAO_INSERIDA, message };
    }
    return { error: false };
}

async function checkNewDateBeforeCurrentDateTimeValidation(
    card: any
): Promise<ValidationResult> {
    if (
        card.cartaoTipo?.cartaoTipoId === TipoCartaoEnum.Intrajornada &&
        checkNewDateBeforeCurrentDateTime(card)
    ) {
        return {
            error: true,
            title: "SALVAR A AGENDA",
            message: "Não é possível inserir intrajornada no passado.",
        };
    }
    if (checkNewDateBeforeCurrentDateTime(card)) {
        return {
            error: true,
            title: "Salvar a Agenda",
            message: "Não é possível inserir atividades no passado.",
        };
    }
    return { error: false };
}

async function dailySpecialClassHoursExceededValidation(
    card: any,
    scheduleEvents: any[]
): Promise<ValidationResult> {
    if (dailySpecialClassHoursExceeded(card, scheduleEvents)) {
        return {
            error: true,
            title: ATIVIDADE_NAO_INSERIDA,
            message: "Você só pode cadastrar 10 horas/aula por dia.",
        };
    }
    return { error: false };
}
async function specialCardsValidationAbono(
    newCard: any,
    scheduleEvents: any[],
    dataAbonos: any[],
    professor: any
): Promise<ValidationResult> {
    const startNewCard = parseISO(newCard.start?.trim());
    if (
        dataAbonos.filter(
            (abono) =>
                Number(abono.centroResultadoId) === professor.cr &&
                abono.date === newCard.data &&
                typeCards(newCard) &&
                validaIntervalo(abono.diaInteiro, startNewCard, abono) &&
                validaTodosProfessores(
                    abono.todosProfessores,
                    abono.docentes,
                    professor
                )
        ).length
    ) {
        return {
            error: true,
            title: ABONO_ADMINISTRATIVO,
            message: MSG_ALOCACAO_NAO_PERMITIDA_ABONO,
        };
    }
    return { error: false };
}
async function specialCardsValidation(
    newCard: any,
    scheduleEvents: any[],
    targetHoliday: Holiday[]
): Promise<ValidationResult> {
    if (
        targetHoliday.filter(
            (holiday) =>
                holiday.type === "N" &&
                holiday.start === newCard.data &&
                typeCards(newCard)
        ).length
    ) {
        return {
            error: true,
            title: FERIADO_OU_RECESSO,
            message: MSG_ALOCACAO_NAO_PERMITIDA_FERIADO_RECESSO,
        };
    }

    if (
        targetHoliday.filter(
            (holiday) =>
                holiday.campus === newCard.abrangencia?.campus &&
                (holiday.type === "R" || holiday.type === "M") &&
                holiday.start === newCard.data &&
                typeCards(newCard)
        ).length
    ) {
        return {
            error: true,
            title: FERIADO_OU_RECESSO,
            message: MSG_ALOCACAO_NAO_PERMITIDA_FERIADO_RECESSO,
        };
    }
    return { error: false };
}
async function checkOverlapValidation(
    card: any,
    scheduleEvents: any[],
    holidays: Holiday[]
): Promise<ValidationResult> {
    if (checkOverlap(card, scheduleEvents, holidays)) {
        return {
            error: true,
            title: "ATIVIDADE NÃO INSERIDA",
            message: "Já existe uma atividade inserida nesse horário.",
        };
    }
    return { error: false };
}

async function hasHourRangeExceededForOvertimeCardsValidation(
    card: any,
    scheduleEvents: any[]
): Promise<ValidationResult> {
    const hasHourRangeExceededForOvertimeCards =
        hourRangeExceededForOvertimeCards(card, scheduleEvents);

    const { exceededYesterdayCards, exceededTomorrowCards } =
        hasHourRangeExceededForOvertimeCards;

    if (exceededYesterdayCards.length > 0 || exceededTomorrowCards.length > 0) {
        const cardsToCheck =
            exceededYesterdayCards.length > 0
                ? exceededYesterdayCards
                : exceededTomorrowCards;
        const dialogText =
            exceededYesterdayCards.length > 0
                ? "O intervalo entre o final da última atividade do dia anterior e o início da primeira atividade do dia subsequente deve ser maior do que 11 horas."
                : "O intervalo entre o final da última atividade do dia posterior e o início da primeira atividade do dia subsequente deve ser maior do que 11 horas..";

        if (checkIfCardsHasCheckin(cardsToCheck)) {
            return {
                error: true,
                message:
                    "Não é possível mover cartões de Hora Letiva RE se existirem cartões com check-in realizado no dia anterior com um intervalo menor que 11 horas.",
            };
        } else {
            return {
                error: true,
                message: dialogText,
                showPromissifiedDialog: false,
                hasHourRangeExceededForOvertimeCards,
            };
        }
    }

    return { error: false };
}

async function hourRangeExceededValidation(
    card: any,
    scheduleEvents: any[]
): Promise<ValidationResult> {
    if (hourRangeExceeded(card, scheduleEvents)) {
        return {
            error: true,
            message:
                "O intervalo entre o final da última atividade do dia anterior e o início da primeira atividade do dia subsequente deve ser maior do que 11 horas.",
        };
    }
    return { error: false };
}

async function checkDoubleIntradayDateValidation(
    card: any,
    scheduleEvents: any[]
): Promise<ValidationResult> {
    if (checkDoubleIntradayDate(card, scheduleEvents)) {
        return {
            error: true,
            title: "INTRAJORNADA",
            message:
                "Já existe uma Intrajornada inserida nesta data. É necessário excluir a atual antes de inserir uma nova.",
        };
    }
    return { error: false };
}

async function checkLastDateBeforeCurrentDateTimeValidation(
    card: any,
    scheduleEvents: any[]
): Promise<ValidationResult> {
    if (checkLastDateBeforeCurrentDateTime(card, scheduleEvents)) {
        return {
            error: true,
            message: "Não é possível mover cartões do passado.",
        };
    }
    return { error: false };
}

async function checkStatusCheckinValidation(
    card: any
): Promise<ValidationResult> {
    if (
        (card.statusCheckin ===
        StatusCheckinEnumLabel.get(StatusCheckinEnum.CheckinRealizado)
        )
    ) {
        return {
            error: true,
            message: "Não é possível mover cartões com o check-in realizado.",
        };
    }

    if (
        card.statusCheckin === "Abono Legal" ||
        card.statusCheckin === "Abono Administrativo"  && 
        card.cartaoTipo.cartaoTipoId !== 11
    ) {
        return {
            error: true,
            message: "Não é possível mover cartões abonados.",
        };
    }

    if (
        [
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Ferias),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.LicencaNaoRemunerada),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.LicencaRemunerada),
            StatusCheckinEnumLabel.get(StatusCheckinEnum.Inativo),
        ].includes(card.statusCheckin)
    ) {
        return {
            error: true,
            message: `Não é possível mover cartões com status de ${card.statusCheckin}.`,
        };
    }

    return { error: false };
}

async function checkCardIsAllocatedAtBlockedPeriod(
    card: any,
    validities: VigenciaPlanoAtividade[]
): Promise<ValidationResult> {
    const { data } = card;
    const error = {
        error: false,
        message: `Agenda bloqueada para edição no dia ${DateUtils.formatStringToBrazilianFormat(
            data
        )}`,
    };

    validities.forEach((validity: VigenciaPlanoAtividade) => {
        if (
            DateUtils.isDateAfterOrEqual(
                new Date(data),
                new Date(validity.planoAtividadeDtInicio)
            ) &&
            DateUtils.isDateBeforeOrEqual(
                new Date(data),
                new Date(validity.planoAtividadeDtFim)
            )
        ) {
            error.error = true;
        }
    });
    return error;
}

const applyValidation = async (
    card: any,
    scheduleEvents: any[],
    isDisabledSaveButton: boolean,
    holidays: Holiday[],
    validities: VigenciaPlanoAtividade[],
    dataAbonos: any[],
    professor: any
): Promise<ValidationResult> => {
    const validations: Array<() => Promise<ValidationResult>> = [
        () => checkCardIsAllocatedAtBlockedPeriod(card, validities),
        () => dailyNormalClassHoursExceededValidation(card, scheduleEvents),
        () =>
            isOvertimeCardValidation(
                card,
                isDisabledSaveButton,
                scheduleEvents
            ),
        () => checkOutValidityPeriodValidation(card),
        () => checkNewDateBeforeCurrentDateTimeValidation(card),
        () => dailySpecialClassHoursExceededValidation(card, scheduleEvents),
        () =>
            specialCardsValidationAbono(
                card,
                scheduleEvents,
                dataAbonos,
                professor
            ),
        () => specialCardsValidation(card, scheduleEvents, holidays),
        () => checkOverlapValidation(card, scheduleEvents, holidays),
        () => hourRangeExceededValidation(card, scheduleEvents),
        () =>
            hasHourRangeExceededForOvertimeCardsValidation(
                card,
                scheduleEvents
            ),
        () => checkDoubleIntradayDateValidation(card, scheduleEvents),
        () =>
            checkLastDateBeforeCurrentDateTimeValidation(card, scheduleEvents),
        () => checkStatusCheckinValidation(card),
    ];

    const validationResult = await validations.reduce(
        async (resultPromise: Promise<ValidationResult>, validation) => {
            const result = await resultPromise;
            if (result.error) {
                return result;
            }
            return validation();
        },
        Promise.resolve({ error: false })
    );

    return validationResult;
};

export {
    applyValidation,
    hourRangeExceededForOvertimeCards,
    checkHolidayCard,
    checkAbonoCard,
    checkLastStatus,
    getHolidayStatus,
};
